import type {
  RoundParty,
  RoundSnapshot,
} from "@/shared/api/types/pvpRoulette"
import { getActiveBets } from "@/shared/api/types/pvpRoulette"
import { getAccountId, getUserIdFromToken } from "@/shared/api/auth"
import { DEFAULT_GROUP_ID } from "@/shared/constants/pvpRoulette"

export function isTeamRoundParty(p: RoundParty): boolean {
  return (
    p.partyType === "TEAM" ||
    p.partyId === DEFAULT_GROUP_ID ||
    p.userId === DEFAULT_GROUP_ID
  )
}

/** Solo sector owned by the user — party.userId may differ from JWT sub on prod. */
export function findSoloPartyForUser(
  snapshot: RoundSnapshot,
  userId: string
): RoundParty | undefined {
  const soloParties = snapshot.parties.filter((p) => !isTeamRoundParty(p))
  const direct = soloParties.find((p) => p.userId === userId)
  if (direct) return direct

  const hasBet = getActiveBets(snapshot.bets).some(
    (b) => b.userData.userId === userId
  )
  if (!hasBet) return undefined

  const byPlayerBank = soloParties.find((p) =>
    p.playerBanks?.some((pb) => pb.userData.userId === userId)
  )
  if (byPlayerBank) return byPlayerBank

  const myBet = getActiveBets(snapshot.bets).find(
    (b) => b.userData.userId === userId
  )
  if (myBet?.partyId) {
    const byPartyId = soloParties.find(
      (p) => p.partyId === myBet.partyId || p.id === myBet.partyId
    )
    if (byPartyId) return byPartyId
  }

  if (soloParties.length === 1) return soloParties[0]
  return undefined
}

/** JWT sub and account UUID can both appear in API payloads — pick the one in this round. */
export function resolveWheelUserId(
  snapshot: RoundSnapshot
): string | undefined {
  const candidates = [getUserIdFromToken(), getAccountId()].filter(
    (id): id is string => Boolean(id)
  )

  for (const id of candidates) {
    if (getActiveBets(snapshot.bets).some((b) => b.userData.userId === id)) {
      return id
    }
  }

  for (const id of candidates) {
    if (findSoloPartyForUser(snapshot, id)) return id
  }

  return candidates[0]
}
